export const LOCALE_STATE_KEY = "LOCALE_STATE";

export const getLocale = (state) => {
    return state[LOCALE_STATE_KEY].locale;
};

export const getLocaleErrMsg = (state) => {
    return state[LOCALE_STATE_KEY].errMessage;
};
